"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const hooks_1 = require("@icr-ui/hooks");
const icons_1 = require("@icr-ui/icons");
const general_1 = require("../../general");
const styles_1 = require("./styles");
const Modal = ({ isOpen, setOpen, width = '60vw', disableBackdropClick = false, children, hasCloseButton = true, onClose, ...rest }) => {
    const isSmallScreen = (0, hooks_1.useMediaQuery)('(max-width: 768px)');
    const innerRef = (0, hooks_1.useClickOutside)(() => !disableBackdropClick && isOpen ? setOpen(false) : undefined);
    const handleClose = () => {
        if (onClose) {
            onClose();
        }
        setOpen(false);
    };
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledModalOverlay, { isOpen: isOpen, fullScreen: true, "data-testid": "modal-overlay", noPadding: isSmallScreen, children: (0, jsx_runtime_1.jsxs)(styles_1.StyledModalWrapper, { noRound: isSmallScreen, ref: innerRef, padding: "lg", flexDirection: "column", width: width, gap: "48px", ...rest, "data-testid": "modal", children: [hasCloseButton && ((0, jsx_runtime_1.jsx)(general_1.Button, { variant: "text", iconButton: true, small: true, onClick: () => handleClose(), className: "modal-close-button", children: (0, jsx_runtime_1.jsx)(icons_1.CloseIcon, { width: "16", height: "16" }) })), children] }) }));
};
exports.Modal = Modal;
exports.default = exports.Modal;
//# sourceMappingURL=modal.js.map